
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.625 1.897c.047-.066.1-.146.167-.255l.14-.23V1.41l.056-.092C5.541.415 5.943 0 6.667 0H10v1.333H6.667c-.058 0-.24.188-.541.681l-.049.08-.15.249c-.083.133-.15.237-.22.333-.298.415-.597.657-1.04.657h-2A.667.667 0 002 4v6c0 .368.299.667.667.667h10.667A.667.667 0 0014 10V6h1.334v4a2 2 0 01-2 2H2.667a2 2 0 01-2-2V4a2 2 0 012-2h1.877c.023-.025.05-.06.081-.103zm6.709 1.436V2h1.333V.667H14V2h1.334v1.333H14v1.334h-1.333V3.333h-1.333zM8 10a3.333 3.333 0 110-6.667A3.333 3.333 0 018 10zm0-1.333a2 2 0 100-4 2 2 0 000 4z","fill":"#fff"}})])
          )
        }
      }
    